import React, {Fragment, useEffect, useState} from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Input, CardBody} from 'reactstrap';
import {mapToCssModules} from "reactstrap/lib/utils";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import axios from "axios";
import Select from "react-select";
import {selectThemeColors} from "../../../utility/Utils";

import FileUploaderMulti from "../../../utility/FIleUploaderMulti";
import {fixFooterButtons} from "../../components/FooterButtons";
import {fixLayoutToFullScreen} from "../NewCompetition/newStep1";

const MySwal = withReactContent(Swal)

const NewSponzorModal = (props) => {
    const {
        toggle,
        isOpen,
        sponsors,
        setSponsors,
        editSponsor
    } = props;

    const [typeOfSponsor, setTypeOfSponsor] = useState("");
    const [options, setOptions] = useState(editSponsor ? {
        label: editSponsor["typeOf"],
        value: editSponsor["typeOf"]
    } : [
        {label: "Regular", value: "Regular"}, {label: "Premium", value: "Premium"}
    ]);
    const [validationFailed, setValidationFailed] = useState(false);
    const [filesDetails, setFilesDetails] = useState(editSponsor ? [{
        uploadUrl: editSponsor.photo,
        name: ""
    }] : []);
    const [name, setName] = useState(editSponsor ? editSponsor.name : "");
    const [description, setDescription] = useState(editSponsor ? editSponsor.description : "");
    let isEdit = !!editSponsor;
    console.log(editSponsor)

    useEffect(() => {
        if (editSponsor) {
            setDescription(editSponsor.description)
            setName(editSponsor.name)
            setFilesDetails([{
                uploadUrl: editSponsor.photo,
                name: ""
            }])
            setTypeOfSponsor({
                label: editSponsor["typeOf"],
                value: editSponsor["typeOf"]
            })
        }

    }, editSponsor)

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>
                Dodaj sponzora
            </ModalHeader>
            <ModalBody>
                <FileUploaderMulti
                    singleFile
                    oneFileOnly
                    title={"Upload fotografije"}
                    fileDetails={filesDetails}
                    setFilesDetails={setFilesDetails}
                />
                {filesDetails.map((number, index) => {
                    return (
                        <Fragment>
                            <a target={"_blank"}
                               href={number.uploadUrl}> {(number.name && number.name !== "") ? number.name : ""}</a><br/>
                        </Fragment>
                    )
                })
                }
                <div style={{height: "50px"}}/>
                <Select
                    placeholder={"Odaberi vrstu sponzora"}
                    theme={selectThemeColors}
                    className='react-select'
                    classNamePrefix='select'
                    value={typeOfSponsor}
                    styles={{
                        marginTop: "50px",
                        control: styles => ({
                            ...styles,
                            borderColor: (validationFailed && typeOfSponsor === "") ? 'red' : styles.borderColor,
                            '&:hover': {
                                borderColor: (validationFailed && typeOfSponsor === "") ? 'red' : styles['&:hover'].borderColor
                            }
                        })
                    }}
                    onChange={(data) => {
                        setTypeOfSponsor(data)
                    }}
                    name='clear'
                    options={options}
                    isClearable={false}
                />
                <div style={{height: "50px"}}/>

                <Input
                    placeholder={"Naziv"}
                    theme={selectThemeColors}
                    className='react-select'
                    classNamePrefix='select'
                    invalid={name === '' && validationFailed}
                    value={name}
                    onChange={(e) => {
                        setName(e.target.value)
                    }}
                />

                <Input
                    type={"textarea"}
                    style={{width: "100%", marginBottom: "30px", marginTop: "50px", height: "75px"}}
                    placeholder={"Opis"}
                    invalid={validationFailed && description === ""}
                    value={description}
                    onChange={(e) => {
                        setDescription(e.target.value)
                    }}
                />

            </ModalBody>
            <ModalFooter>
                <div className='row justify-content-center text-center' style={{width: "100%"}}>
                    <div className={"col"}>
                        <Button.Ripple onClick={() => {
                            props.toggle();
                        }}
                                       type='submit'
                                       color='danger'
                                       className='btn-next'>
                            <span className='align-middle d-sm-inline-block d-none'>Odustani</span>
                        </Button.Ripple>
                    </div>
                    <div className={"col"}>
                        <Button.Ripple onClick={() => {
                            let photos = [];
                            filesDetails.map((fileDetail) => {
                                photos.push(fileDetail.uploadUrl);
                            })
                            if (typeOfSponsor === "" || description === "" || name === "") {
                                setValidationFailed(true);
                                return;
                            }
                            console.log(photos)
                            if (editSponsor) {
                                axios.post(`${process.env.REACT_APP_MAIN_URL}/admin/edit-sponsor`, {
                                    sponsorId: editSponsor._id,
                                    competition: props.competition._id,
                                    competitionId: props.competition._id,
                                    description,
                                    name,
                                    photo: (photos && photos.map && photos.length > 0 && photos[0]) ? photos[0] : null,
                                    typeOf: typeOfSponsor.value
                                }).then(() => {
                                    let sponsorsNew = sponsors.map((oneSponsor) => {
                                        if (editSponsor && oneSponsor.name == editSponsor.name) {
                                                oneSponsor.name = name
                                                oneSponsor.description = description;
                                                oneSponsor.typeOf = typeOfSponsor.value;
                                        }
                                        return oneSponsor
                                    })
                                    setSponsors([...sponsorsNew]);
                                    MySwal.fire({
                                        icon: 'success',
                                        title: 'Uspješno',
                                        text: 'Sponzor uređen',
                                        customClass: {
                                            confirmButton: 'btn btn-success'
                                        }
                                    })
                                    setDescription("")
                                    setFilesDetails([])
                                    setValidationFailed(false)
                                    setTypeOfSponsor("")
                                    setFilesDetails([])
                                    setName("")
                                    toggle();
                                    fixFooterButtons()
                                }).catch((e) => {
                                    console.log(e)
                                    window.alert("Nesto je poslo po krivu. Probajte ponovno")
                                })
                            } else {
                                let newSpnosors = [...sponsors];
                                newSpnosors.push({
                                    name,
                                    photo: photos[0],
                                    typeOf: typeOfSponsor.value,
                                    description
                                })

                                setSponsors([...newSpnosors]);

                                MySwal.fire({
                                    icon: 'success',
                                    title: 'Uspješno',
                                    text: 'Dodan sponzor',
                                    customClass: {
                                        confirmButton: 'btn btn-success'
                                    }
                                })
                                setDescription("")
                                setFilesDetails([])
                                setValidationFailed(false)
                                setTypeOfSponsor("")
                                setFilesDetails([])
                                setName("")
                                toggle();
                                fixFooterButtons()
                            }


                        }} type='submit' color='primary' className='btn-next'>
                            <span className='align-middle d-sm-inline-block d-none'>{editSponsor ? "Uredi" : "Dodaj"}</span>
                        </Button.Ripple>
                    </div>
                </div>
            </ModalFooter>
        </Modal>

    );
}

export default NewSponzorModal;